import { ref, onMounted, onBeforeUnmount } from 'vue';
import { resolveAssignmentOptions } from './assignmentOptions';

const EVENTS = [
  'hkele:chatwoot-assignment-options-changed',
  'hkele:chatwoot-extension-host-ready',
];

export function useAssignmentOptions() {
  const revision = ref(0);
  const update = () => {
    revision.value += 1;
  };
  onMounted(() =>
    EVENTS.forEach(event => window.addEventListener(event, update))
  );
  onBeforeUnmount(() =>
    EVENTS.forEach(event => window.removeEventListener(event, update))
  );
  const resolve = (options, context) => {
    // Track asynchronous roster/settings changes while a menu is already open.
    return resolveAssignmentOptions(
      options,
      { ...context, extensionRevision: revision.value },
      window.ChatwootExtensions
    ).map(({ agent }) => agent);
  };
  const notice = context =>
    window.ChatwootExtensions?.getAssignmentNotice?.({
      ...context,
      extensionRevision: revision.value,
    }) || '';
  return { resolve, notice };
}
